import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "image"]
  static values = { url: String }

  connect() {
    console.log("HeaderImageController connected")
  }

  async generate(event) {
    event.preventDefault()

    if (!this.urlValue) {
      console.error("No URL configured for header image generation")
      return
    }

    // Update button to show loading state
    const originalContent = this.buttonTarget.innerHTML
    this.buttonTarget.disabled = true
    this.buttonTarget.innerHTML = `
      <svg class="animate-spin w-4 h-4 mr-1" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      Generating...
    `

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
        }
      })

      const data = await response.json()

      if (data.success) {
        // Update the image
        if (this.hasImageTarget) {
          if (this.imageTarget.tagName === "IMG") {
            this.imageTarget.src = data.url
          } else {
            // Replace the placeholder div with an actual image
            const img = document.createElement("img")
            img.src = data.url
            img.alt = ""
            img.className = "w-full h-full object-cover"
            img.dataset.headerImageTarget = "image"
            this.imageTarget.replaceWith(img)
          }
        }

        // Update button text
        this.buttonTarget.innerHTML = `
          <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
          </svg>
          Regenerate Image
        `
        this.buttonTarget.disabled = false
      } else {
        alert(data.error || "Failed to generate image")
        this.buttonTarget.innerHTML = originalContent
        this.buttonTarget.disabled = false
      }
    } catch (error) {
      console.error("Header image generation error:", error)
      alert("Error generating image. Please try again.")
      this.buttonTarget.innerHTML = originalContent
      this.buttonTarget.disabled = false
    }
  }
}

